import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';

import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { ScoreModalComponent } from '../../../modals/score-modal/score-modal.component';

import { UserMenuDataService } from '../../../services/menu.service';

import *  as Classes from '../../../classes/models.classes'

import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-sponsored-posts',
    templateUrl: './sponsored-posts.component.html',
    styleUrls: ['./sponsored-posts.component.css']
})
export class SponsoredPostsComponent implements OnInit {
    //@Input() postData: any;
    @Input() UserID: number;

    @Output() hasData = new EventEmitter<boolean>();

    //@Output() reactionsUpdated = new EventEmitter<any>();

    sponsoredPosts: any[] = [];

    private searchSubject = new Subject<string>();

    constructor(
        private userMenuDataService: UserMenuDataService,
        private router: Router,
        private modalService: NgbModal,
        private http: HttpClient
    ) {
    }

    ngOnInit() {
        this.loadSponsoredPosts();
    }

    loadSponsoredPosts() {
        this.userMenuDataService.getSponsoredPosts(this.UserID).subscribe(
            (sponsoredPosts) => {
                this.sponsoredPosts = sponsoredPosts;
                this.hasData.emit(sponsoredPosts.length > 0);
            },
            (error) => {
                console.error('Error loading suggested users:', error);
                this.hasData.emit(false);
            }
        );
    } 

}
